import React from "react";
import { Icon } from "@mui/material";

const DragHandle = ({ onDragStart, id, sx }) => (
  <Icon
    draggable
    onDragStart={(e) => onDragStart(e, id)}
    sx={{ cursor: "grab", color: "#7b80a7", ...sx }}
    fontSize="small"
  >
    drag_indicator
  </Icon>
);

export default DragHandle;
